import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';

import DatePresenter, {
  SHORT_FORMAT,
} from '../../../../presenters/DatePresenter';
import Group from '../../../../components/Group';
import Row from '../../../../components/Row';
import Column from '../../../../components/Column';
import { Label, ErrorFlash } from '../../../../components';

import FormHeader from './components/FormHeader';

const Form = (props) => {
  const {
    onSubmit,
    onAuth0IdUpdate,
    onStartDateChange,
    onEndDateChange,
    errors,
    auth0Id,
    startDate,
    endDate,
    onBlockDialogOpen,
    fastCash,
    onUnblockAccount,
    onShowLogsClick,
    isFlagUser,
    handleFlagUser,
    handleUnFlagUser,
  } = props;

  return (
    <form className="user-find-form" onSubmit={onSubmit}>
      <FormHeader
        onBlockDialogOpen={onBlockDialogOpen}
        onUnblockAccount={onUnblockAccount}
        onShowLogsClick={onShowLogsClick}
        fastCash={fastCash}
        isFlagUser={isFlagUser}
        handleFlagUser={handleFlagUser}
        handleUnFlagUser={handleUnFlagUser}
      />
      <ErrorFlash errors={errors} message={errors} />
      <Group>
        <Row>
          <Column>
            <Label attr="auth0Id" text="Auth0 id" />
            <input
              type="text"
              id="auth0Id"
              value={auth0Id}
              onChange={onAuth0IdUpdate}
            />
          </Column>
        </Row>
        <Row className="dates">
          <Column className="date">
            <Label attr="startDate" text="Start date" />
            <DatePicker
              selected={DatePresenter.dateObject(startDate)}
              onChange={onStartDateChange}
              dateFormat="MM-dd-yyyy"
            />
          </Column>
          <Column className="date">
            <Label attr="endDate" text="End date" />
            <DatePicker
              selected={DatePresenter.dateObject(endDate)}
              onChange={onEndDateChange}
              dateFormat="MM-dd-yyyy"
            />
          </Column>
        </Row>
      </Group>
    </form>
  );
};

Form.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onAuth0IdUpdate: PropTypes.func.isRequired,
  onStartDateChange: PropTypes.func.isRequired,
  onEndDateChange: PropTypes.func.isRequired,
  errors: PropTypes.shape(),
  auth0Id: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  onBlockDialogOpen: PropTypes.func.isRequired,
  fastCash: PropTypes.shape(),
  onUnblockAccount: PropTypes.func.isRequired,
  onShowLogsClick: PropTypes.func.isRequired,
};

export default Form;

Form.defaultProps = {
  errors: null,
};
